import {Checkbox, Flex, Form, Skeleton} from 'antd';
import {useMemo} from 'react';

import {Text} from '../../../../../../component/text/text';
import {spacer_xs} from '../../../../../../css/var-export.scss';
import {RatingStar} from '../../../../../../layout/rating-star-line/rating-star/rating-star';
import {FormattedNumber} from '../../../../../../provider/locale/formatted-number';
import {Locale} from '../../../../../../provider/locale/locale';
import * as styles from '../reviews-filter.scss';
import {ReviewsFilterFieldNameEnum} from '../reviews-filter-type';

type RatingEntryType = {
    rating: number;
    count: number;
};

type PropsType = {
    ratingOptions: Array<RatingEntryType>;
    totalReviewsLabelCount: number;
    displayedAverageRating: number;
    isReviewsStatisticFetching: boolean;
    ratingList: Array<number>;
    onRatingChange: (value: Array<number>) => void;
};

export function ReviewsFilterRatingSection(props: PropsType): JSX.Element {
    const {
        ratingOptions,
        totalReviewsLabelCount,
        displayedAverageRating,
        isReviewsStatisticFetching,
        ratingList,
        onRatingChange,
    } = props;

    const checkboxOptions = useMemo(
        () =>
            ratingOptions.map(({rating, count}) => ({
                label: (
                    <Flex gap={8}>
                        {rating === 0 ? (
                            <Text>
                                <Locale stringKey="REVIEWS__RADIO__NOT_RATED" />
                            </Text>
                        ) : (
                            <Flex>
                                <RatingStar fillPercent={100} height={22} width={20} />
                                <Text>&nbsp;{rating}</Text>
                            </Flex>
                        )}
                        <Text className={styles.ReviewsFilter_ratingText} secondary small>
                            {isReviewsStatisticFetching ? (
                                <Skeleton.Input active className={styles.ReviewsFilter_ratingSkeleton} size="small" />
                            ) : (
                                <FormattedNumber value={count} />
                            )}
                        </Text>
                    </Flex>
                ),
                value: rating,
            })),
        [ratingOptions, isReviewsStatisticFetching]
    );

    return (
        <Flex className={styles.ReviewsFilter_ratingSection} gap={spacer_xs} vertical>
            <Form.Item
                label={
                    <Text
                        bolder
                        stringKey="REVIEWS__FILTER__LABEL__TOTAL_REVIEWS_WITH_COUNT"
                        valueMap={{
                            count: isReviewsStatisticFetching ? (
                                <Skeleton.Input active className={styles.ReviewsFilter_ratingSkeleton} size="small" />
                            ) : (
                                <FormattedNumber value={totalReviewsLabelCount} />
                            ),
                        }}
                    />
                }
                name={ReviewsFilterFieldNameEnum.ratingList}
            >
                <Checkbox.Group
                    onChange={(value) => onRatingChange(value.map(Number))}
                    options={checkboxOptions}
                    rootClassName={styles.ReviewsFilter_ratingCheckboxWrapper}
                    value={ratingList}
                />
            </Form.Item>
            <Text
                block
                secondary
                small
                stringKey="REVIEWS__FILTER__LABEL__AVERAGE_RATING"
                valueMap={{
                    rating: isReviewsStatisticFetching ? (
                        <Skeleton.Input active className={styles.ReviewsFilter_ratingSkeleton} size="small" />
                    ) : (
                        <FormattedNumber options={{maximumFractionDigits: 1}} value={displayedAverageRating} />
                    ),
                }}
            />
        </Flex>
    );
}
